<template>
    <div class="skeleton">
        <div class="skeleton__header" v-if="hideHeader">
            <div class="skeleton__header--container">
                <div class="skeleton__header-item" />
                <div class="skeleton__header-item" />
            </div>
        </div>
        <div class="skeleton__container">
            <section class="skeleton__section">
                <div v-for="(item, index) in skeletonItems" :key="index" :class="item.class" />
                <div class="skeleton__btn" v-if="showButton" />
            </section>
            <section class="skeleton__section">
                <div class="skeleton__large" />
            </section>
        </div>
    </div>
</template>

<script>
export default {
	data() {
		return {
			skeletonItems: [
				{ class: 'skeleton__medium' },
				{ class: 'skeleton__content' },
				{ class: 'skeleton__medium' },
				{ class: 'skeleton__content' },
				{ class: 'skeleton__medium' },
				{ class: 'skeleton__content' },
				{ class: 'skeleton__medium' },
				{ class: 'skeleton__content' },
			]
		};
	},
  props: {
    hideHeader: {
      type: Boolean,
      default: false
    }
  },
	computed: {
		showButton() {
			return window.innerWidth <= 1024;
		}
	}
};
</script>

<style lang="scss" scoped>
$skeleton-background: #EEF0F3;
$skeleton-border-radius: 8px;

.skeleton {
  width: 100%;
  display: flex;
  flex-direction: column;
  min-height: 100%;

  &__header {
	  padding: 20px;
	  border-bottom: 1px solid #b8c1cc;

	  &--container {
		max-width: 1180px;
		margin: 0 auto;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

    &-item {
      width: 100%;
      max-width: 112px;
      height: 24px;
	  background: $skeleton-background;
      border-radius: $skeleton-border-radius;
    }
  }

  &__container {
	width: 100%;
	max-width: 1180px;
	padding: 48px 0;
	margin: 0 auto;
	display: flex;

	@media screen and (max-width: 1024px) {
		flex-direction: column;
		justify-content: center;
		padding: 20px;
	}
  }

  &__section {
	&:first-child {
		margin-right: 60px;
    	width: calc(55% - 60px);
	}

	&:last-child {
		margin-left: 60px;
    	width: calc(45% - 60px);
	}

	@media screen and (max-width: 1024px) {
		&:first-child {
			width: 100%;
			order: 2;
			margin-right: 0;
			.skeleton__medium:nth-child(7),
			.skeleton__content:nth-child(8) {
				display: none;
			}
		}

		&:last-child {
			width: 100%;
			order: 1;
			margin-left: 0;
		}
	}
  }

  &__medium {
    width: 376px;
    height: 24px;
    border-radius: $skeleton-border-radius;
    margin-bottom: 10px;

	@media screen and (max-width: 1024px) {
		width: 100%;
		max-width: 112px;
		height: 24px;

		&:nth-child(4) {
			display: none;
		}
	}
  }

  &__content {
    width: 480px;
    height: 80px;
    margin-bottom: 32px;
    border-radius: $skeleton-border-radius;

	@media screen and (max-width: 1024px) {
		width: 100%;
		height: 80px;
	}
  }

  &__btn {
	display: none;

	@media screen and (max-width: 1024px) {
		display: block;
		width: 100%;
		height: 48px;
		border-radius: $skeleton-border-radius;
		margin-top: 150px;
	}
  }

  &__large {
    width: 480px;
    height: 220px;
    border-radius: $skeleton-border-radius;

	@media screen and (max-width: 1024px) {
		width: 100%;
		height: 132px;
		margin-bottom: 16px;
	}
  }

  &__medium,
  &__content,
  &__large,
  &__btn {
	background: $skeleton-background;
  }
}
</style>
